import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9b010a44")

_pushScopeId("data-v-9b010a44")
const _hoisted_1 = {
  key: 0,
  class: "reportComfirm_carInfo"
}
const _hoisted_2 = { class: "reportComfirm_carInfo_brand" }
const _hoisted_3 = { class: "reportComfirm_carInfo_brand_carMes" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "电池检测: ", -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "电池健康度（SOH）: ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_reportComfirmTitle = _resolveComponent("reportComfirmTitle")

  return (_ctx.renderData.batteryDetect && _ctx.renderData.batterySOH)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_reportComfirmTitle, {
          titleTxt: "电池检测",
          isShowRight: true,
          goPageType: "basic"
        }),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_ctx.renderData.batteryDetect)
              ? (_openBlock(), _createBlock("p", _hoisted_4, [
                  _hoisted_5,
                  _createTextVNode(_toDisplayString(_ctx.renderData.batteryDetect), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.renderData.batterySOH)
              ? (_openBlock(), _createBlock("p", _hoisted_6, [
                  _hoisted_7,
                  _createTextVNode(_toDisplayString(_ctx.renderData.batterySOH), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})